import Box from '@mui/material/Box'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'

const steps = [
  { label: 'Revisit Priorities', value: 0 },
  { label: 'Impact', value: 1 },
  { label: 'Health', value: 2 },
]

type CheckInSurveyStepperProps = { completed?: boolean; step: number }

export const CheckInSurveyStepper = ({
  completed,
  step,
}: CheckInSurveyStepperProps) => {
  if (!steps.find((s) => s.value === step)?.label) return null

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={step} alternativeLabel>
        {steps.map(({ label }) => (
          <Step completed={completed} key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}
